import cx from "classnames";
import React from "react";

import "./BreakdownContent.scss";

export interface IBreakdownContentProps {
  limitWidth?: boolean;
}

const BreakdownContent: React.FC<
  React.PropsWithChildren<IBreakdownContentProps>
> = (props) => (
  <div
    className={cx("c-breakdown-content", {
      "c-breakdown-content--limit-width": props.limitWidth,
    })}
  >
    {props.children}
  </div>
);

export default BreakdownContent;
